const NO_SERVABLE_OFFERS = 'Every offer in this Smartlink has a weight of 0, so there is nothing to serve'

export function canActivateSl(sl) {
    return sl.active_offers > 0
}

export function slToggleBlocked(sl) {
    return sl.status !== 'ACTIVE' && !canActivateSl(sl)
}

export function slToggleTitle(sl) {
    return slToggleBlocked(sl) ? NO_SERVABLE_OFFERS : ''
}

export function confirmSlActivation(sl) {
    if (sl.snapshot_placements > 0) {
        return window.confirm(
            `Activate "${sl.name}"?\n\n` +
            `It will not be put back on the ${sl.snapshot_placements} placement(s) it was removed from, ` +
            `and they will be discarded.\n\n` +
            `Use Re-launch instead to put it back on them.`
        )
    }

    return window.confirm(`Activate "${sl.name}"?`)
}
